import { useAppSelector } from 'app/config/store';
import React from 'react';

export const DoNotShowInProduction = props => {
  const inProductionState = useAppSelector(state => state.inProductionButton.inProduction);

  return inProductionState === false ? <>{props.children}</> : null;
};

export default DoNotShowInProduction;
